// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1nI4J","amount":"Amount_amount__19kOI","tip":"Amount_tip__1nZcj","tipHeader":"Amount_tipHeader__3ZlLI","tipsWrap":"Amount_tipsWrap__YKSM1"};